import { AppContextState } from "src/AppContextProvider";
import { canAccessScreensManager } from "src/domains/screensManager/permissions";

export const shouldDisplayScreensManagerMenu = (
  context: AppContextState,
): boolean => {
  return canAccessScreensManager(context);
};
